import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const tools = [
  "Flutter",
  "Jakarta EE",
  "Springboot",
  "React",
  "Next.js",
  "REST",
  "GraphQL",
  "Docker",
];

export default function About() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.utils.toArray("[data-about-reveal]").forEach((el) => {
        gsap.fromTo(
          el,
          { opacity: 0, y: 30 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: "power3.out",
            scrollTrigger: { trigger: el, start: "top 85%" },
          }
        );
      });
    }, sectionRef);
    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={sectionRef}
      id="about"
      className="px-6 py-16 md:px-12 md:py-24 border-t border-ink/10"
    >
      <div data-about-reveal className="mb-12 md:mb-16">
        <span className="font-mono text-xs tracking-widest uppercase text-ink/40 block mb-3">
          Background
        </span>
        <h2 className="font-serif text-4xl md:text-6xl font-bold">About</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16">
        {/* Portrait placeholder */}
        <div data-about-reveal className="opacity-0">
          <div className="aspect-[3/4] bg-ink/5 border border-ink/10 flex items-center justify-center">
            <span className="font-mono text-xs text-ink/20 tracking-widest uppercase">
              Portrait
            </span>
          </div>
        </div>

        {/* Bio */}
        <div className="flex flex-col justify-center gap-8">
          <div data-about-reveal className="opacity-0">
            <p className="font-sans text-lg md:text-xl text-ink/80 leading-relaxed mb-4">
              I'm a fullstack developer specializing in mobile apps and
              enterprise web applications — building scalable, reliable systems
              that power real businesses.
            </p>
            <p className="font-sans text-base text-ink/50 leading-relaxed">
              From cross-platform mobile development to complex backend
              architectures, I deliver end-to-end solutions built for
              performance and longevity. Every line of code is written with
              production-grade standards in mind.
            </p>
          </div>

          {/* Tools */}
          <div data-about-reveal className="opacity-0">
            <span className="font-mono text-xs tracking-widest uppercase text-ink/40 block mb-4">
              Tools & Technologies
            </span>
            <div className="flex flex-wrap gap-2">
              {tools.map((tool) => (
                <span
                  key={tool}
                  className="font-mono text-xs tracking-wider text-ink/50 border border-ink/10 px-3 py-1.5"
                >
                  {tool}
                </span>
              ))}
            </div>
          </div>

          {/* Contact CTA */}
          <div data-about-reveal className="opacity-0">
            <a
              href="mailto:emmanuelawuah.dev@gmail.com"
              data-cursor-hover
              className="inline-block font-mono text-xs tracking-widest uppercase border border-ink px-6 py-3 text-ink no-underline hover:bg-ink hover:text-paper transition-all duration-300"
            >
              Get in touch
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
